import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Meil on suur valik outlet kaupa, mis on põnev valik neile, kes otsivad soodsaid viimaseid eksemplare lühikese tarneajaga.

  <span style="color:#85c1dc;">**FI:**</span>
  Tule ON24-asiakkaaksi ja lahjoitamme sinulle ON24-rahaa, jolla saat tuotteista lisäalennusta!

  <span style="color:#85c1dc;">**RU:**</span>
  Станьте нашим постоянным клиентом и за присоединение мы подарим Вам на счет деньги, за которые Вы сможете получить дополнительную скидку на товары!
*/
/* @__NO_SIDE_EFFECTS__ */
const m1166 = msg(
  mf`Meil on suur valik outlet kaupa, mis on põnev valik neile, kes otsivad soodsaid viimaseid eksemplare lühikese tarneajaga.`,
  mf`Tule ON24-asiakkaaksi ja lahjoitamme sinulle ON24-rahaa, jolla saat tuotteista lisäalennusta!`,
  mf`Станьте нашим постоянным клиентом и за присоединение мы подарим Вам на счет деньги, за которые Вы сможете получить дополнительную скидку на товары!`,
)

export { m1166 as 'w.basket.empty.third.text' }